module.exports = __webpack_public_path__ + "img/3.70c57758.jpg";